// eslint-disable-next-line max-classes-per-file
import hashSum from 'hash-sum';

export interface Point {
  lat?: number;
  latitude?: number;
  lng?: number;
  longitude?: number;
  className?: string;
}

class DataPoint {
  static validatePoint = ({ lat, lng, latitude, longitude }: Point) =>
    (Boolean(lat) && Boolean(lng)) || (Boolean(latitude) && Boolean(longitude));

  // eslint-disable-next-line no-undef
  dataMap: Record<string, Point> = {};

  pointsCount = 0;

  lat: Point['lat'] | Point['latitude'];

  lng: Point['lng'] | Point['longitude'];

  className: Point['className'];

  opacity: Number = 1;

  addPoint = pointItem => {
    const dataHash = hashSum(pointItem);
    const { lat, lng, latitude, longitude, className } = pointItem;

    this.dataMap[dataHash] = pointItem;
    this.lat = lat || latitude;
    this.lng = lng || longitude;
    this.className = className;
    this.pointsCount += 1;
  };

  constructor(point: Point, opacity: Number = 1) {
    this.addPoint(point);
    this.opacity = opacity;
  }

  hasPoint = point => this.dataMap[hashSum(point)] !== undefined;

  getPoints = () => Object.values(this.dataMap);

  getLatLng = () => [this.lat, this.lng];
}

class DataPointMap {
  static generateLatLngHash = (point: Point) => {
    if (DataPoint.validatePoint(point)) {
      let { lat, lng } = point;
      const { latitude, longitude } = point;

      lat = lat || latitude;
      lng = lng || longitude;
      return hashSum(`${lat.toFixed(4)}${lng.toFixed(4)}`);
    }

    return 0;
  };

  // eslint-disable-next-line no-undef
  pointsByHash: Record<string, DataPoint> = {};

  size = 0;

  constructor(points: Point[]) {
    points.forEach(point => {
      if (DataPoint.validatePoint(point)) {
        this.addPoint(point);
      }
    });
  }

  addPoint = point => {
    const hash = DataPointMap.generateLatLngHash(point);
    let dataPoint = this.pointsByHash[hash];

    if (dataPoint) {
      // Костыль для того чтобы точки в 2gis не собирались в кучу
      const parsedPoint = { ...point };
      if (dataPoint.pointsCount === 1) {
        parsedPoint.latitude = Number(
          (parsedPoint.latitude + 0.0002).toFixed(5)
        );
        parsedPoint.longitude = Number(
          (parsedPoint.longitude + 0.0002).toFixed(5)
        );
      } else if (dataPoint.pointsCount === 2) {
        parsedPoint.latitude = Number(
          (parsedPoint.latitude - 0.0002).toFixed(5)
        );
        parsedPoint.longitude = Number(
          (parsedPoint.longitude - 0.0002).toFixed(5)
        );
      }
      dataPoint.addPoint(new DataPoint(parsedPoint, 0));
    } else {
      dataPoint = new DataPoint(new DataPoint(point));
      this.pointsByHash[hash] = dataPoint;
      this.size += 1;
    }
  };

  map = (callback: (point: Point, hash: string) => void) =>
    Object.entries(this.pointsByHash).map(({ 0: hash, 1: point }) =>
      callback(point, hash)
    );

  get = index => Object.values(this.pointsByHash)[index];
}

export default DataPointMap;
